import clsx from "clsx";

/** "Sara Ahmed" is "SA"; a single name gives its first two letters ("Sara" is "SA"). Empty gives "?". */
export function initialsOf(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean);
  const first = words[0];
  if (!first) return "?";
  const last = words.length > 1 ? words[words.length - 1] : undefined;
  const letters = last ? `${Array.from(first)[0] ?? ""}${Array.from(last)[0] ?? ""}` : Array.from(first).slice(0, 2).join("");
  return letters.toUpperCase();
}

export interface AvatarProps {
  /** The person's name. It names the avatar for screen readers and gives the initials unless `initials` is set. */
  name?: string;
  initials?: string;
  /** A person is a round avatar with initials. The agent is a square badge that says "AI" (rebuild decision D9). */
  kind?: "person" | "ai";
  size?: "sm" | "md";
  /** Hide the avatar from screen readers, where the words beside it already say who wrote them. */
  decorative?: boolean;
  className?: string;
}

/** The round avatar of a person, or the square "AI" badge that marks what the agent wrote. */
export function Avatar({ name = "", initials, kind = "person", size = "md", decorative = false, className }: AvatarProps) {
  const ai = kind === "ai";
  const text = ai ? "AI" : (initials ?? initialsOf(name));
  const label = ai ? "AI" : name || text;
  return (
    <span
      role={decorative ? undefined : "img"}
      aria-label={decorative ? undefined : label}
      aria-hidden={decorative ? true : undefined}
      className={clsx("avatar", ai && "avatar--ai", `avatar--${size}`, className)}
      data-kind={kind}
    >
      <span aria-hidden="true">{text}</span>
    </span>
  );
}
